import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { Scope } from 'src/app/shared/enum/scope.enum';
import { NavigationEntry } from 'src/app/shared/model/navigationEntry.class';
import { environment } from 'src/environments/environment';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit {

  public links: NavigationEntry[];
  public links2: NavigationEntry[];
  public url: string;

  constructor(
    public sidebarService: SidebarService,
    private _authService: AuthService,
  ) {
    this.url = 'company/edit/' + this.getCompanyId().toString(); }

  ngOnInit() {
    // console.log(this.url);
    this.links = [
      // new NavigationEntry(
      //   {
      //     title: 'Navigation',
      //     isSeparator: true,
      //     scope: [Scope.Default, Scope.ListDashboard]
      //   }
      // ),
      new NavigationEntry(
        {
          title: 'Startseite',
          url: 'home',
          // icon: 'dashboard',
          scope: [Scope.Default]
        }
      ),

      new NavigationEntry(
        {
          title: '',
          isSeparator: true,
          // scope: [Scope.ListCompanies, Scope.ListEmployees, Scope.ListUsers, Scope.ListUserByCompany, Scope.ListScopes, Scope.ListUserRoles, Scope.UpdateOwnCompany, Scope.ListOwnCompany]
        }
      ),
      new NavigationEntry(
        {
          title: 'Neue Firma anlegen',
          url: 'company/add',
          scope: [Scope.CreateCompany]
        }
      ),
      new NavigationEntry(
        {
          title: 'Firmenverwaltung',
          url: 'company/management',
          // icon: 'business',
          scope: [Scope.ListCompanies]
        }
      ),
    ];
    if(this._authService.isCompanyAdmin()){
      this.links.push(
        new NavigationEntry(
          {
            title: 'Firma bearbeitung',
            // url: this.url,
            url: 'company/edit/own',
            scope: [Scope.UpdateOwnCompany, Scope.ListOwnCompany]
          }
        ),
      )
    }
    this.links = this.links.concat(
      [
      new NavigationEntry(
        {
          title: 'Benutzerverwaltung',
          url: 'user',
          // icon: 'people_alt',
          scope: [Scope.ListUsers, Scope.ListUserByCompany]
        }
      ),
      ]
    )

    if(this._authService.getUserId() == 110){
      this.links.push(
        new NavigationEntry(
          {
            title: 'Rechteverwaltung',
            url: 'right',
            // icon: 'https',
            scope: [Scope.ListScopes]
          }
        ),
      )
    }
    this.links = this.links.concat(
      [
      new NavigationEntry(
        {
          title: 'Rollenverwaltung',
          url: 'user-role',
          // icon: 'groups_2',
          scope: [Scope.ListUserRoles]
        }
      ),
      new NavigationEntry(
        {
          title: 'Gästezugänge',
          url: 'qrcodes/management',
          // icon: 'groups_2',
          // scope: [Scope.ListUserRoles]
        }
      ),
    ])
      if(this._authService.isSuperAdmin()) {
        this.links.push()}
      // new NavigationEntry(
      //   {
      //     title: 'Fahrradverwaltung',
      //     url: 'bicycle',
      //     // icon: 'groups_2',
      //     // scope: [Scope.ListUserRoles]
      //   }
      // ),
    if(!this._authService.isCompanyAdmin()){
      this.links.push(
      new NavigationEntry(
        {
          title: 'Openhouse',
          url: 'open-house',
          // icon: 'groups_2',
          // scope: [Scope.ListUserRoles]
        }
      ),
      )
    }

    if(this._authService.isSuperAdmin() || this._authService.isCompanyAdmin()){
      this.links.push(
        new NavigationEntry(
          {
            title: 'Informationen',
            url: 'information',
          }
        ),
      )
    }

    // if(this._authService.isSuperAdmin()){
    //   this.links.push(
    //     new NavigationEntry(
    //       {
    //         title: 'E-Bike ausleihen',
    //         url: 'ilockit',
    //         // extraclass: 'disabled',
    //         scope: [Scope.Default]
    //       }
    //     ),
    //   )
    // }

    // if(this._authService.isSuperAdmin() || this._authService.isCompanyAdmin()){
    //   this.links.push(
    //     new NavigationEntry(
    //       {
    //         title: 'Schließfächer (Coming soon)',
    //         url: 'vecos',
    //         // extraclass: 'disabled',
    //         scope: [Scope.Default]
    //       }
    //     ),
    //   )
    // }

    this.links = this.links.concat(
      [
      // new NavigationEntry(
      //   {
      //     title: 'Coming soon',
      //     isSeparator: true,
      //     scope: [Scope.Default]
      //   }
      // ),
      new NavigationEntry(
        {
          title: '',
          isSeparator: true,
          isGrow: true,
          scope: [Scope.Default]
        }
      ),
      // new NavigationEntry(
      //   {
      //     title: 'AGB',
      //     url: 'agb',
      //     // icon: 'info',
      //     scope: [Scope.Default]
      //   }
      // ),
      new NavigationEntry(
        {
          title: 'Impressum',
          url: 'impressum',
          // icon: 'info',
          scope: [Scope.Default]
        }
      ),
      new NavigationEntry(
        {
          title: 'Datenschutz',
          url: 'datenschutz',
          // icon: 'info',
          scope: [Scope.Default]
        }
      ),
      new NavigationEntry(
        {
          title: 'Nutzung',
          url: 'nutzung',
          // icon: 'info',
          scope: [Scope.Default]
        }
      ),
      new NavigationEntry(
        {
          title: 'Abmelden',
          url: 'login',
          // icon: 'https',
          scope: [Scope.Default]
        }
      ),
    ]);
    // if(!environment.production) {
    //   // Show list of components within one page if the app is not in production mode
    //   this.links.push(new NavigationEntry(
    //     {
    //       title: 'Components',
    //       url: 'components-overview',
    //       // icon: 'apps',
    //       scope: [Scope.Default]
    //     }
    //   ));
    // }
  }

  public isAuthorized(scopes : Scope[]) {
    if(scopes.length > 0) {
      return this._authService.hasRight(scopes);
    }
    return false;
  }

  public logout() {
    this._authService.logout();
  }

  routeAction(link: NavigationEntry) {
    if(link.title.toLowerCase() == 'abmelden') this.logout();
    if(this.sidebarService.isMobile) this.sidebarService.toggleSidebar();
  }

  public getCompanyId() {
      return this._authService.getCompanyId();
  }

}
